import { useToggle } from 'ahooks';
import { CareemAddIcon, ExtraWashbagIcon } from 'assets/icons';
import GettingBagBottomsheet from 'components/organisms/BottomSheets/HowDoWeGetBagsBottomSheet';
import * as React from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

const StyledDiv = styled.div`
  border-width: 1px;
  border: 1px solid ${({ theme }) => theme.colors.ghostWhite};
  border-radius: ${({ theme }) => theme.components.howDoIGetBagsCard.borderRadius}px;
  margin-top: 11px;
  padding: 8px;
  padding-right: ${({ theme }) => theme.components.howDoIGetBagsCard.padding.right}px;
  padding-left: ${({ theme }) => theme.components.howDoIGetBagsCard.padding.left}px;
`;

const Title = styled.h3`
  color: ${(props) => props.theme.colors.charcoal};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.4px;
  flex: 1;
  margin: 0;
`;

interface GetTheBagsOptionWithSheetProps {}

const GetTheBagsOptionWithSheet: React.FC<GetTheBagsOptionWithSheetProps> = () => {
  const { t } = useTranslation();
  const [showGettingBagBottomsheet, { setRight, setLeft }] = useToggle(false);

  const onGettingBagClick = React.useCallback(() => {
    setRight();
  }, [setRight]);

  return (
    <>
      <StyledDiv onClick={onGettingBagClick}>
        <Row className="px-4 align-items-center">
          <ExtraWashbagIcon className="mr-2" />
          <Title>{t('common.howDoIGetTheBagsHeading')}</Title>
          <CareemAddIcon className="mr-2" />
        </Row>
      </StyledDiv>
      <GettingBagBottomsheet show={showGettingBagBottomsheet} onClose={setLeft} />
    </>
  );
};

export default GetTheBagsOptionWithSheet;
